import { render } from "./SpecialRequest.vue?vue&type=template&id=51b3c183&scoped=true"
import script from "./SpecialRequest.vue?vue&type=script&lang=js"
export * from "./SpecialRequest.vue?vue&type=script&lang=js"

import "./SpecialRequest.vue?vue&type=style&index=0&id=51b3c183&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b3c183"]])

export default __exports__